/**
 * Contributor domain entry for hen-site (same `@hen-site/types/*` pattern as layout/dashboard).
 * Implementation lives in `src/lib/contributors/`.
 */
export * from '../lib/contributors';
